import { all, fork, put, takeEvery, call, takeLatest } from 'redux-saga/effects';
import { InboundActionTypes } from './constants';
import { toast, ToastContainer } from 'react-toastify';
import {
    inbound,
    createInbound,
    updateInbound,
    deleteInbound,
    tagNo,
    tagData,
    updateAll,
    updateAllYards,
    updateSelected,
    updateSelectedUnit,
    updateInventoryTransactions,
    uploadInbound,
    gatDetailsbyTag,
    getByDoc,
    getPrintContent,
    getExcelContent,
    updateTagnoByStatus,
    updateAllSellingPrice,
    updateSelectedDescription,
    updateAllDescription,
    getInvoiceData,
    getReceiverData,
    updateAllUnits,
    editInboundDataApi,
} from './api';
/**
 * Login the user
 * @param {*} payload - username and password
 */

// ---------------------------------------------------------------I N B O U N D----------------------------------------------------------------

function* getInboundFunction(data) {
    try {
        yield put({
            type: InboundActionTypes.INBOUND_DATA_LOADING,
            payload: {},
        });
        const response = yield call(inbound, data);
        if (response.data.status) {
            yield put({
                type: InboundActionTypes.INBOUND_DATA_SUCCESS,
                payload: { ...response.data },
            });
        } else {
            yield put({
                type: InboundActionTypes.INBOUND_DATA_ERROR,
                payload: { ...response.data },
            });
            // toast.error(response?.data?.message);
        }
    } catch (error) {
        toast.error(error);
        yield put({
            type: InboundActionTypes.INBOUND_DATA_ERROR,
            payload: error,
        });
    }
}

function* getEditInboundDataFunction(data) {
    try {
        yield put({
            type: InboundActionTypes.GET_EDIT_INBOUND_DATA_LOADING,
            payload: {},
        });
        const response = yield call(editInboundDataApi, data);
        if (response.data.status) {
            yield put({
                type: InboundActionTypes.GET_EDIT_INBOUND_DATA_SUCCESS,
                payload: { ...response.data },
            });
        } else {
            yield put({
                type: InboundActionTypes.GET_EDIT_INBOUND_DATA_ERROR,
                payload: { ...response.data },
            });
        }
    } catch (error) {
        toast.error(error);
        yield put({
            type: InboundActionTypes.GET_EDIT_INBOUND_DATA_ERROR,
            payload: error,
        });
    }
}


function* createInboundFunction(data) {
    try {
        yield put({
            type: InboundActionTypes.CREATE_INBOUND_DATA_LOADING,
            payload: {},
        });
        const response = yield call(createInbound, data);
        if (response?.data?.status) {
            if (!localStorage.getItem('uniqueId') && response?.data?.uniqueId) {
                localStorage.setItem('uniqueId', JSON.stringify(response.data.uniqueId));
                localStorage.setItem('parentId', JSON.stringify(response.data.parentId));
            }
            // toast.success(response.data.message);
            yield put({
                type: InboundActionTypes.CREATE_INBOUND_DATA_SUCCESS,
                payload: { ...response.data },
            });
        } else {
            // toast.error(response?.data?.message);

            yield put({
                type: InboundActionTypes.CREATE_INBOUND_DATA_ERROR,
                payload: { ...response.data },
            });
        }
    } catch (error) {
        toast.error(error);
        yield put({
            type: InboundActionTypes.CREATE_INBOUND_DATA_ERROR,
            payload: error,
        });
    }
}

function* uploadInboundFunction(data) {
    try {
        yield put({
            type: InboundActionTypes.UPLOAD_INBOUND_DATA_LOADING,
            payload: {},
        });
        const response = yield call(uploadInbound, data);
        if (response.data.status) {
            yield put({
                type: InboundActionTypes.UPLOAD_INBOUND_DATA_SUCCESS,
                payload: { ...response.data },
            });

        } else {
            yield put({
                type: InboundActionTypes.UPLOAD_INBOUND_DATA_ERROR,
                payload: { ...response.data },
            });

        }
    } catch (error) {
        toast.error(error);
        yield put({
            type: InboundActionTypes.UPLOAD_INBOUND_DATA_ERROR,
            payload: error,
        });

    }
}

function* updateInboundFunction(payload) {
    try {
        yield put({
            type: InboundActionTypes.UPDATE_INBOUND_DATA_LOADING,
        });

        const response = yield call(updateInbound, payload);

        if (response && response.data && response.data.status === 200) {
            // toast.success(response.data.message);

            yield put({
                type: InboundActionTypes.UPDATE_INBOUND_DATA_SUCCESS,
                payload: response.data,
            });
        } else {
            // toast.error(response?.data?.message);

            yield put({
                type: InboundActionTypes.UPDATE_INBOUND_DATA_ERROR,
                payload: response.data,
            });
        }
    } catch (error) {
        toast.error(error);
        yield put({
            type: InboundActionTypes.UPDATE_INBOUND_DATA_ERROR,
            payload: { message: error.message },
        });
    }
}
function* updateAllFunction(payload) {
    try {
        yield put({
            type: InboundActionTypes.UPDATE_ALL_DATA_LOADING,
        });

        const response = yield call(updateAll, payload);

        if (response && response.data && response.data.status === 200) {
            // toast.success(response.data.message);

            yield put({
                type: InboundActionTypes.UPDATE_ALL_DATA_SUCCESS,
                payload: response.data,
            });
        } else {
            // toast.error(response?.data?.message);

            yield put({
                type: InboundActionTypes.UPDATE_ALL_DATA_ERROR,
                payload: response.data,
            });
        }
    } catch (error) {
        toast.error(error);
        yield put({
            type: InboundActionTypes.UPDATE_ALL_DATA_ERROR,
            payload: { message: error.message },
        });
    }
}
function* updateAllYardsFunction(payload) {
    try {
        yield put({
            type: InboundActionTypes.UPDATE_ALL_YARDS_LOADING,
        });

        const response = yield call(updateAllYards, payload);

        if (response && response.data && response.data.status === 200) {
            yield put({
                type: InboundActionTypes.UPDATE_ALL_YARDS_SUCCESS,
                payload: response.data,
            });

        } else {
            // toast.error(response?.data?.message);

            yield put({
                type: InboundActionTypes.UPDATE_ALL_YARDS_ERROR,
                payload: response.data,
            });
        }
    } catch (error) {
        toast.error(error);
        yield put({
            type: InboundActionTypes.UPDATE_ALL_YARDS_ERROR,
            payload: { message: error.message },
        });
    }
}
function* updateSelecteFunction(payload) {
    try {
        yield put({
            type: InboundActionTypes.UPDATE_SELECTED_DATA_LOADING,
        });

        const response = yield call(updateSelected, payload);

        if (response && response.data && response.data.status === 200) {
            // toast.success(response.data.message);

            yield put({
                type: InboundActionTypes.UPDATE_SELECTED_DATA_SUCCESS,
                payload: response.data,
            });
        } else {
            // toast.error(response?.data?.message);

            yield put({
                type: InboundActionTypes.UPDATE_SELECTED_DATA_ERROR,
                payload: response.data,
            });
        }
    } catch (error) {
        toast.error(error);
        yield put({
            type: InboundActionTypes.UPDATE_SELECTED_DATA_ERROR,
            payload: { message: error.message },
        });
    }
}
function* updateSelectedUnitFunction(payload) {
    try {
        yield put({
            type: InboundActionTypes.UPDATE_SELECTED_UNIT_DATA_LOADING,
        });

        const response = yield call(updateSelectedUnit, payload);

        if (response && response.data && response.data.status === 200) {
            yield put({
                type: InboundActionTypes.UPDATE_SELECTED_UNIT_DATA_SUCCESS,
                payload: response.data,
            });

        } else {
            yield put({
                type: InboundActionTypes.UPDATE_SELECTED_UNIT_DATA_ERROR,
                payload: response.data,
            });
            // toast.error(response?.data?.message);
        }
    } catch (error) {
        toast.error(error);
        yield put({
            type: InboundActionTypes.UPDATE_SELECTED_UNIT_DATA_ERROR,
            payload: { message: error.message },
        });
    }
}

function* deleteInboundFunction(payload) {
    try {
        yield put({
            type: InboundActionTypes.DELETE_INBOUND_DATA_LOADING,
        });

        const response = yield call(deleteInbound, payload);

        if (response && response.data && response.data.status === 200) {
            // toast.success(response.data.message);

            yield put({
                type: InboundActionTypes.DELETE_INBOUND_DATA_SUCCESS,
                payload: response.data,
            });
        } else {
            // toast.error(response?.data?.message);

            yield put({
                type: InboundActionTypes.DELETE_INBOUND_DATA_ERROR,
                payload: response.data,
            });
        }
    } catch (error) {
        toast.error(error);
        yield put({
            type: InboundActionTypes.DELETE_INBOUND_DATA_ERROR,
            payload: { message: error.message },
        });
    }
}
// _---------------------------_--_--_--_--_-_--_--_-_-----T A G --------_-_----_-____-_-_--_-_--_-_--_-----------------------------
function* getTagFunction(data) {
    try {
        yield put({
            type: InboundActionTypes.TAG_DATA_LOADING,
            payload: {},
        });
        const response = yield call(tagNo, data);
        if (response.data.status) {
            yield put({
                type: InboundActionTypes.TAG_DATA_SUCCESS,
                payload: { ...response.data },
            });
            // toast.success(response.data.message);
        } else {
            yield put({
                type: InboundActionTypes.TAG_DATA_ERROR,
                payload: { ...response.data },
            });
            // toast.error(response?.data?.message);
        }
    } catch (error) {
        toast.error(error);
        yield put({
            type: InboundActionTypes.TAG_DATA_ERROR,
            payload: error,
        });
    }
}

function* getTagDataFunction(data) {
    try {
        yield put({
            type: InboundActionTypes.TAG_NO_LOADING,
            payload: {},
        });
        const response = yield call(tagData, data);
        if (response.data) {
            yield put({
                type: InboundActionTypes.TAG_NO_SUCCESS,
                payload: { ...response.data },
            });
        } else {
            yield put({
                type: InboundActionTypes.TAG_NO_ERROR,
                payload: { ...response.data },
            });
        }
    } catch (error) {
        toast.error(error);
        yield put({
            type: InboundActionTypes.TAG_NO_ERROR,
            payload: error,
        });
    }
}

function* updateTransactionFunction(payload) {
    try {
        yield put({
            type: InboundActionTypes.UPDATE_INVENTORY_TRANSACTIONS_DATA_LOADING,
        });

        const response = yield call(updateInventoryTransactions, payload);

        if (response && response.data && response.data.status === 200) {
            // toast.success(response.data.message);

            yield put({
                type: InboundActionTypes.UPDATE_INVENTORY_TRANSACTIONS_DATA_SUCCESS,
                payload: response.data,
            });
        } else {
            // toast.error(response?.data?.message);

            yield put({
                type: InboundActionTypes.UPDATE_INVENTORY_TRANSACTIONS_DATA_ERROR,
                payload: response.data,
            });
        }
    } catch (error) {
        toast.error(error);
        yield put({
            type: InboundActionTypes.UPDATE_INVENTORY_TRANSACTIONS_DATA_ERROR,
            payload: { message: error.message },
        });
    }
}

function* getByTagFunction(payload) {
    try {
        yield put({
            type: InboundActionTypes.GET_DETAILS_BY_TAG_LOADING,
        });

        const response = yield call(gatDetailsbyTag, payload);

        if (response && response.data) {
            yield put({
                type: InboundActionTypes.GET_DETAILS_BY_TAG_SUCCESS,
                payload: response.data,
            });
            // toast.success(response.data.message);
        } else {
            yield put({
                type: InboundActionTypes.GET_DETAILS_BY_TAG_ERROR,
                payload: response.data,
            });
            // toast.error(response?.data?.message);
        }
    } catch (error) {
        toast.error(error);
        yield put({
            type: InboundActionTypes.GET_DETAILS_BY_TAG_ERROR,
            payload: { message: error.message },
        });
    }
}

function* getByDocFunction(payload) {
    try {
        yield put({
            type: InboundActionTypes.GET_BY_DOC_LOADING,
        });

        const response = yield call(getByDoc, payload);

        if (response && response.data) {
            yield put({
                type: InboundActionTypes.GET_BY_DOC_SUCCESS,
                payload: response.data,
            });
            // toast.success(response.data.message);
        } else {
            yield put({
                type: InboundActionTypes.GET_BY_DOC_ERROR,
                payload: response.data,
            });
            // toast.error(response?.data?.message);
        }
    } catch (error) {
        toast.error(error);
        yield put({
            type: InboundActionTypes.GET_BY_DOC_ERROR,
            payload: { message: error.message },
        });
    }
}

function* getPrintContentFunction(payload) {
    try {
        yield put({
            type: InboundActionTypes.GET_PRINT_CONTENT_LOADING,
        });

        const response = yield call(getPrintContent, payload);

        if (response && response.data) {
            yield put({
                type: InboundActionTypes.GET_PRINT_CONTENT_SUCCESS,
                payload: response.data,
            });
            // toast.success(response.data.message);
        } else {
            yield put({
                type: InboundActionTypes.GET_PRINT_CONTENT_ERROR,
                payload: response.data,
            });
            // toast.error(response?.data?.message);
        }
    } catch (error) {
        toast.error(error);
        yield put({
            type: InboundActionTypes.GET_PRINT_CONTENT_ERROR,
            payload: { message: error.message },
        });
    }
}
function* getExcelContentFunction(payload) {
    try {
        yield put({
            type: InboundActionTypes.GET_EXCEL_CONTENT_LOADING,
        });

        const response = yield call(getExcelContent, payload);

        if (response && response.data) {
            yield put({
                type: InboundActionTypes.GET_EXCEL_CONTENT_SUCCESS,
                payload: response.data,
            });
            // toast.success(response.data.message);
        } else {
            yield put({
                type: InboundActionTypes.GET_EXCEL_CONTENT_ERROR,
                payload: response.data,
            });
            // toast.error(response?.data?.message);
        }
    } catch (error) {
        toast.error(error);
        yield put({
            type: InboundActionTypes.GET_EXCEL_CONTENT_ERROR,
            payload: { message: error.message },
        });
    }
}

function* updateTagByStatusFunction(payload) {
    try {
        yield put({
            type: InboundActionTypes.UPDATE_TAG_BY_STATUS_LOADING,
        });

        const response = yield call(updateTagnoByStatus, payload);

        if (response && response.data.status === 200) {
            // toast.success(response.data.message);

            yield put({
                type: InboundActionTypes.UPDATE_TAG_BY_STATUS_SUCCESS,
                payload: response.data,
            });
        } else {
            // toast.error(response?.data?.message);

            yield put({
                type: InboundActionTypes.UPDATE_TAG_BY_STATUS_ERROR,
                payload: response.data,
            });
        }
    } catch (error) {
        toast.error(error);
        yield put({
            type: InboundActionTypes.UPDATE_TAG_BY_STATUS_ERROR,
            payload: error,
        });
    }
}
function* updateAllSellingPriceFunction(payload) {
    try {
        yield put({
            type: InboundActionTypes.UPDATE_ALL_SELLING_PRICE_LOADING,
        });

        const response = yield call(updateAllSellingPrice, payload);

        if (response && response.data && response.data.status === 200) {
            // toast.success(response.data.message);

            yield put({
                type: InboundActionTypes.UPDATE_ALL_SELLING_PRICE_SUCCESS,
                payload: response.data,
            });
        } else {
            // toast.error(response?.data?.message);

            yield put({
                type: InboundActionTypes.UPDATE_ALL_SELLING_PRICE_ERROR,
                payload: response.data,
            });
        }
    } catch (error) {
        toast.error(error);
        yield put({
            type: InboundActionTypes.UPDATE_ALL_SELLING_PRICE_ERROR,
            payload: { message: error.message },
        });
    }
}
function* updateAllDescriptionFunction(payload) {
    try {
        yield put({
            type: InboundActionTypes.UPDATE_ALL_DESCRIPTION_LOADING,
        });

        const response = yield call(updateAllDescription, payload);

        if (response && response.data && response.data.status === 200) {
            toast.success(response.data.message);

            yield put({
                type: InboundActionTypes.UPDATE_ALL_DESCRIPTION_SUCCESS,
                payload: response.data,
            });
        } else {
            toast.error(response?.data?.message);

            yield put({
                type: InboundActionTypes.UPDATE_ALL_DESCRIPTION_ERROR,
                payload: response.data,
            });
        }
    } catch (error) {
        toast.error(error);
        yield put({
            type: InboundActionTypes.UPDATE_ALL_DESCRIPTION_ERROR,
            payload: { message: error.message },
        });
    }
}
function* updateAllUnitsFunction(payload) {
    try {
        yield put({
            type: InboundActionTypes.UPDATE_ALL_UNITS_LOADING,
        });

        const response = yield call(updateAllUnits, payload);

        if (response && response.data && response.data.status === 200) {
            toast.success(response.data.message);

            yield put({
                type: InboundActionTypes.UPDATE_ALL_UNITS_SUCCESS,
                payload: response.data,
            });
        } else {
            toast.error(response?.data?.message);

            yield put({
                type: InboundActionTypes.UPDATE_ALL_UNITS_ERROR,
                payload: response.data,
            });
        }
    } catch (error) {
        toast.error(error);
        yield put({
            type: InboundActionTypes.UPDATE_ALL_UNITS_ERROR,
            payload: { message: error.message },
        });
    }
}
function* updateSelectedDescriptionFunction(payload) {
    try {
        yield put({
            type: InboundActionTypes.UPDATE_SELECTED_DESCRIPTION_LOADING,
        });

        const response = yield call(updateSelectedDescription, payload);

        if (response && response.data && response.data.status === 200) {
            toast.success(response.data.message);

            yield put({
                type: InboundActionTypes.UPDATE_SELECTED_DESCRIPTION_SUCCESS,
                payload: response.data,
            });
        } else {
            toast.error(response?.data?.message);

            yield put({
                type: InboundActionTypes.UPDATE_SELECTED_DESCRIPTION_ERROR,
                payload: response.data,
            });
        }
    } catch (error) {
        toast.error(error);
        yield put({
            type: InboundActionTypes.UPDATE_SELECTED_DESCRIPTION_ERROR,
            payload: { message: error.message },
        });
    }
}

function* getInvoiceDataFunction(payload) {
    try {
        yield put({
            type: InboundActionTypes.GET_INVOICE_DATA_LOADING,
        });

        const response = yield call(getInvoiceData, payload);

        if (response && response.data && response.data.status === 200) {
            toast.success(response.data.message);

            yield put({
                type: InboundActionTypes.GET_INVOICE_DATA_SUCCESS,
                payload: response.data,
            });
        } else {
            toast.error(response?.data?.message);

            yield put({
                type: InboundActionTypes.GET_INVOICE_DATA_ERROR,
                payload: response.data,
            });
        }
    } catch (error) {
        toast.error(error);
        yield put({
            type: InboundActionTypes.GET_INVOICE_DATA_ERROR,
            payload: { message: error.message },
        });
    }
}

function* getReceiverDataFunction(payload) {
    try {
        yield put({
            type: InboundActionTypes.GET_RECEIVER_DATA_LOADING,
        });

        const response = yield call(getReceiverData, payload);

        if (response && response.data && response.data.status === 200) {
            toast.success(response.data.message);

            yield put({
                type: InboundActionTypes.GET_RECEIVER_DATA_SUCCESS,
                payload: response.data,
            });
        } else {
            toast.error(response?.data?.message);

            yield put({
                type: InboundActionTypes.GET_RECEIVER_DATA_ERROR,
                payload: response.data,
            });
        }
    } catch (error) {
        toast.error(error);
        yield put({
            type: InboundActionTypes.GET_RECEIVER_DATA_ERROR,
            payload: { message: error.message },
        });
    }
}


export function* watchGetInbound() {
    yield takeLatest(InboundActionTypes.INBOUND_DATA_FIRST, getInboundFunction);
    yield takeLatest(InboundActionTypes.GET_EDIT_INBOUND_DATA_FIRST, getEditInboundDataFunction);
    yield takeLatest(InboundActionTypes.TAG_DATA_FIRST, getTagFunction);
    yield takeLatest(InboundActionTypes.TAG_NO_FIRST, getTagDataFunction);
    yield takeLatest(InboundActionTypes.GET_DETAILS_BY_TAG_FIRST, getByTagFunction);
    yield takeLatest(InboundActionTypes.GET_BY_DOC_FIRST, getByDocFunction);
    yield takeEvery(InboundActionTypes.GET_PRINT_CONTENT_FIRST, getPrintContentFunction);
    yield takeEvery(InboundActionTypes.GET_EXCEL_CONTENT_FIRST, getExcelContentFunction);
    yield takeEvery(InboundActionTypes.GET_INVOICE_DATA_FIRST, getInvoiceDataFunction);
    yield takeLatest(InboundActionTypes.GET_RECEIVER_DATA_FIRST, getReceiverDataFunction);
}
export function* watchCreateInbound() {
    yield takeEvery(InboundActionTypes.CREATE_INBOUND_DATA_FIRST, createInboundFunction);
    yield takeEvery(InboundActionTypes.UPLOAD_INBOUND_DATA_FIRST, uploadInboundFunction);
    yield takeEvery(InboundActionTypes.UPDATE_ALL_DESCRIPTION_FIRST, updateAllDescriptionFunction);
    yield takeEvery(InboundActionTypes.UPDATE_SELECTED_DESCRIPTION_FIRST, updateSelectedDescriptionFunction);
}
export function* watchUpdateInbound() {
    yield takeLatest(InboundActionTypes.UPDATE_INBOUND_DATA_FIRST, updateInboundFunction);
    yield takeLatest(InboundActionTypes.UPDATE_ALL_DATA_FIRST, updateAllFunction);
    yield takeLatest(InboundActionTypes.UPDATE_ALL_YARDS_FIRST, updateAllYardsFunction);
    yield takeLatest(InboundActionTypes.UPDATE_SELECTED_DATA_FIRST, updateSelecteFunction);
    yield takeLatest(InboundActionTypes.UPDATE_SELECTED_UNIT_DATA_FIRST, updateSelectedUnitFunction);
    yield takeLatest(InboundActionTypes.UPDATE_INVENTORY_TRANSACTIONS_DATA_FIRST, updateTransactionFunction);
    yield takeLatest(InboundActionTypes.UPDATE_TAG_BY_STATUS_FIRST, updateTagByStatusFunction);
    yield takeLatest(InboundActionTypes.UPDATE_ALL_SELLING_PRICE_FIRST, updateAllSellingPriceFunction);
    yield takeLatest(InboundActionTypes.UPDATE_ALL_UNITS_FIRST, updateAllUnitsFunction);
}
export function* watchDeleteInbound() {
    yield takeEvery(InboundActionTypes.DELETE_INBOUND_DATA_FIRST, deleteInboundFunction);
}

function* boundSaga() {
    yield all([fork(watchGetInbound), fork(watchCreateInbound), fork(watchUpdateInbound), fork(watchDeleteInbound)]);
}
<ToastContainer autoClose={5500} />

export default boundSaga;
